import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-mp-black pt-14 pb-16 md:pt-20 md:pb-24" data-id="element-153" data-mp="4n9z0lnv3m4r">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-60" aria-hidden="true" data-id="element-154" data-mp="128yzydv6bxz6" />
      <div className="pointer-events-none absolute -top-40 right-0 h-[520px] w-[520px] rounded-full opacity-50 md:right-10" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.35), transparent 65%)'
    }} aria-hidden="true" data-id="element-155" data-mp="xb5slhi4wxxb" />
      <Container className="relative z-10" data-id="element-156" data-mp="3d1sayygxbltn">
        <div className="flex flex-col items-center gap-12 md:flex-row md:items-center md:gap-8" data-id="element-157" data-mp="3czfk1vt6u14g">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut
        }} className="w-full md:w-[52%]" data-id="element-158" data-mp="384js0vnybdrc">
            <SectionTag tone="lime" data-id="element-159" data-mp="39acwgl67hgrf">Para monitores y entrenadores de pádel</SectionTag>

            <h1 className="mt-5 font-heading text-4xl font-semibold uppercase leading-[1.05] text-mp-white sm:text-5xl md:text-[3.2rem]" data-id="element-160" data-mp="39cpbapgo3b09">
              Deja de perder horas preparando tus clases de pádel.
            </h1>

            <p className="mt-6 max-w-[650px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-161" data-mp="358hoixtrs54o">
              Un sistema práctico con ejercicios, progresiones, sesiones y una metodología profesional listos para
              implementar en tus clases.
            </p>

            <p className="mt-4 max-w-[600px] text-sm leading-relaxed text-mp-gray/80" data-id="element-162" data-mp="2vgtwovtawm2o">
              5 tomos + herramientas prácticas para organizar mejor tus clases, aportar más valor a tus alumnos y
              profesionalizar tu trabajo dentro y fuera de la pista.
            </p>

            {/* Mobile mockup sits before the CTA */}
            <div className="mt-8 md:hidden" data-id="element-163" data-mp="nb1kz5gpvtwy">
              <HeroMockup priority data-id="element-164" data-mp="na06er0hspah" />
            </div>

            <CTAButton href="#oferta" className="mt-8 w-full sm:w-auto" showArrow data-id="element-165" data-mp="ibgnkzh73tmc">
              Quiero Maestro en Pista
            </CTAButton>

            <p className="mt-4 text-center text-xs text-mp-gray sm:text-left sm:text-sm" data-id="element-166" data-mp="db2cf8kas3k3">
              ✓ Acceso inmediato &nbsp; ✓ 100% digital &nbsp; ✓ Consulta desde móvil, tablet u ordenador
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut,
          delay: 0.1
        }} className="hidden w-full md:block md:w-[48%]" data-id="element-167" data-mp="112g5jgq9w364">
            <HeroMockup priority data-id="element-168" data-mp="3lui8ypr8oxku" />
          </motion.div>
        </div>
      </Container>
    </section>;
}
function HeroMockup({
  priority = false
}: {
  priority?: boolean;
}) {
  return <div className="relative" data-id="element-169" data-mp="1xam54pmyxoye">
      <div className="pointer-events-none absolute inset-0 -z-10 rounded-full opacity-70 blur-2xl" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.4), transparent 70%)'
    }} aria-hidden="true" data-id="element-170" data-mp="1x786nshfdzw8" />
      <img src={FULL_MOCKUP_URL} alt="Kit completo Maestro en Pista: 5 tomos, 5 bonos y Kit de Ejecución" width={800} height={800} fetchPriority={priority ? 'high' : 'auto'} loading={priority ? 'eager' : 'lazy'} className="mx-auto w-full max-w-[560px] drop-shadow-2xl" data-id="element-171" data-mp="2b1984tzri10a" />
    </div>;
}